import React, { useEffect, useState } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CardSolution from '../components/CardSolution'
import Button from '../components/Button'
import * as Icon from 'react-feather'
import EsriFooter from '../components/EsriFooter'
import ProductModal from '../components/Modals/ProductModal'
// import commonService from '../services/commonService'
import DashboardDemos from '../components/DashboardDemos'
import { usePost, useGet } from "../libs/service/api";
import { getDashBoardData } from "./DashboardData"
import { useParams, useHistory } from "react-router-dom";
import TableGIS from '../components/tables/TableGIS'
import TablePZChart from '../components/tables/TablePZChart'
import TablePW from '../components/tables/TablePW'
import cookie from "../libs/cookie/client";
import Loader from "../components/loader";
import viewproloader from '../assets/svg/viewproloader.svg'
const Dashboard = props => {

    const { toast, snackbar } = require('tailwind-toast')
    let { needsassesmentid } = useParams();
    let { email } = useParams();
    const history = useHistory();
    const [productModalVisible, setProductModalVisible] = useState(false)
    const [selectedDataList, setSelectedDataList] = useState([]);
    const [otherProducts, setOtherProducts] = useState([]);
    const [dashboardIdList, setDashboardIdList] = useState([]);
    const [dashboardOtherIdList, setDashboardOtherIdList] = useState([]);
    const [dashboardTabs, setdashboardTabs] = useState([]);
    const [activeid, setActiveid] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [features, setFeatures] = useState();
    const [tabLength, setTabLength] = useState();
    // const [ckuserid, setCKUserid] = useState(cookie.getItem("userid"));
    // const [isLogin, setIsLogin] = useState(false)
    const dashboardData = getDashBoardData();
    // const [needsAssesmentID, setNeedsAssesmentID] = useState(cookie.getItem("needsassesmentid"));
    const GetIdList = () => {
        var array = [];
        return useGet("/commonapi/newdashboard?needsassesmentid=" + needsassesmentid).then(res => {
            setIsLoading(true)
            setTabLength(res.Data.Table.length)
            cookie.setItem('datatablength', res.Data.Table.length);
            // console.log("array");
            // console.log(array);
            // console.log(res.Data);
            // console.log("A6");
            // console.log(cookie.getItem('needsassesmentid'))
            // console.log(res.Data.Table[0].ID);
            // console.log(res.Data.Table.dashboardname);
            // console.log(res.Data.Table1);
            // console.log(res.Data.Table2);
            // console.log(dashboardData);

            if (!res.ErrorState) {

                var data = res.Data.Table;

                for (let j = 0; j < data.length; j++) {
                    if (j === 0) {
                        var obj = {
                            dashboardid: data[j].dashboardid,
                            dashboardname: data[j].dashboardname,
                            ID: data[j].ID,
                            active: true
                        }
                    } else {
                        var obj = {
                            dashboardid: data[j].dashboardid,
                            dashboardname: data[j].dashboardname,
                            ID: data[j].ID,
                            active: false
                        }
                    }
                    array.push(obj)
                }

                var productData = res.Data.Table1;

                var arrObj = []
                for (let i = 0; i < productData.length; i++) {
                    var dataObj = [];
                    for (let j = 0; j < dashboardData.length; j++) {
                        dataObj = dashboardData.filter(c => c.IDList == productData[i].IDList)
                    }
                    arrObj.push(dataObj)
                }

                let feature = res.Data.Table[0].dashboardname.substring(0, 2);
                if (feature == "PZ") {
                    setFeatures(<TablePZChart />)
                } else if (feature == "PW") {
                    setFeatures(<TablePW />)
                } else {
                    setFeatures(<TableGIS />)
                }

                setdashboardTabs(array)
                setDashboardIdList(res.Data.Table1);
                setSelectedDataList(res.Data.Table1.filter(c => c.NeedsAssesmentID == res.Data.Table[0].ID)); //for multiple
                setDashboardOtherIdList(res.Data.Table2);
                setOtherProducts(res.Data.Table2.filter(c => c.NeedsAssesmentID == res.Data.Table[0].ID));  // for multiple
                setIsLoading(false);
                setActiveid(res.Data.Table[0].ID);
                // cookie.setItem('Assactiveid', activeid);
                // setSelectedDataList(res.Data.Table1.filter(c => c.dashboardid == res.Data.Table[0].dashboardid))  // for singal
                // setOtherProducts(res.Data.Table2.filter(c => c.dashboardid == res.Data.Table[0].dashboardid)) // for singal
            } else {
                console.log("Error");
            }
        })
    }

    const onDashboardClick = (item, index, array) => {
        array.map((item) => {
            item.active = false;
        })
        if (item.active == undefined) {
            item.active = true;

        } else {
            item.active = !item.active
        }
        setSelectedDataList(dashboardIdList.filter(c => c.NeedsAssesmentID == item.ID))   //for multiple
        setOtherProducts(dashboardOtherIdList.filter(c => c.NeedsAssesmentID == item.ID))  // for multiple
        setdashboardTabs([...array])
        // setSelectedDataList(dashboardIdList.filter(c => c.dashboardid == item.dashboardid)) // for singal
        // setOtherProducts(dashboardOtherIdList.filter(c => c.dashboardid == item.dashboardid)) // for singal

        let feature = item.dashboardname.substring(0, 2)
        // console.log(feature);
        if (feature == "PZ") {
            setFeatures(<TablePZChart />)
        } else if (feature == "PW") {
            setFeatures(<TablePW />)
        } else {
            setFeatures(<TableGIS />)
        }

        for (let i = 0; i < dashboardTabs.length; i++) {
            if (dashboardTabs[i].active) {
                setActiveid(dashboardTabs[i].ID)
            }
        }
    }

    const TakeNewJourney = () => {
        // if (cookie.getItem("userid") !== undefined) {
        //     if (cookie.getItem("userid") > 0) {
        //         history.push('/area-of-interest/')
        //     } else {
        //         history.push('/login/')
        //     }
        // } else {
        //     history.push('/login/')
        // }
        // history.push('/area-of-interest/')
        // let dataLength = cookie.getItem('datatablength')
        if (tabLength < 5) {
            history.push('/area-of-interest/')
        } else {
            toast().success('', 'Maximum Journey Reached ').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'center',
                positionY: 'top',
                color: 'text-white bg-primary border-primary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()
        }
    }

    const EditAnswer = () => {
        history.push('/area-of-interest/' + activeid)
        // cookie.setItem("activeTabId",activeid)
        // history.push('/area-of-interest/')
        // console.log(cookie.getItem("activeTabId"));
    }

    useEffect(() => {
        GetIdList();
    }, []);


    return (
        <DashboardLayout hideAccountDropdown={true}>
            {cookie.getItem("username") && <h2 className="text-xle font-semibold">Welcome <span className="text-primary">{cookie.getItem("username")}</span> to your Engagement Dashboard</h2>}
            <div className="mt-8">
                <div className="flex flex-row xl:flex-row xl:items-center max-w-260 2xl:max-w-332  flex-wrap">
                    {isLoading && (
                        <div className="bg-primary-light border-2 flex-shrink-0 flex justify-center items-center whitespace-nowrap bg-opacity-30 border-primary border-b-0 border-opacity-40 py-3.5 px-8 mx-2 rounded-t-md mr-3">
                            <img src={viewproloader} width="48%" height="48%" className="m-auto" alt="Loading..." />
                        </div>
                    )}
                    {!isLoading && (
                        <div className='flex flex-wrap'>
                            {
                                dashboardTabs.map((item, index, array) => {
                                    return item.active ? <button className="bg-primary border-2 flex-shrink-0 flex justify-center items-center whitespace-nowrap bg-opacity-10 border-primary border-b-0 border-opacity-40 font-bold py-3.5 px-8 mx-2 rounded-t-md mr-3 hoverefdb text-primary drop-shadow-lg" key={index} onClick={() => { onDashboardClick(item, index, array) }}>{item.dashboardname} <div className="hoverpzdb">{cookie.getItem("username") + "'s Journey"}</div> </button>
                                        :
                                        <button className="bg-primary-light border-2 flex-shrink-0 flex justify-center items-center whitespace-nowrap bg-opacity-30 border-primary border-b-0 border-opacity-20 font-bold py-3.5 px-8 mx-2 rounded-t-md mr-3 hoverefdb text-primary text-opacity-50" onClick={() => { onDashboardClick(item, index, array) }}>{item.dashboardname}<div className="hoverpzdb">{cookie.getItem("username") + "'s Journey"}</div></button>
                                })
                            }
                        </div>
                    )}
                    <div className=" pl-1 flex justify-center items-center  max-w-260 2xl:max-w-332 flex-wrap">
                        {tabLength < 5 ? <button className="flex cursor-pointer" onClick={() => { TakeNewJourney() }}><Icon.PlusCircle className="w-6 h-6 mr-2" aria-hidden="true" />Take a journey again</button> : <button className="flex cursor-pointer opacity-60" onClick={() => { TakeNewJourney() }}><Icon.PlusCircle className="w-6 h-6 mr-2" aria-hidden="true" />Take a journey again</button>}
                        <div className="flex ml-auto pl-4">
                            <button className="p-2 cursor-pointer hover:bg-vp rounded"><Icon.Upload className="w-6 hidden" /></button>
                            <button className="p-2 cursor-pointer hover:bg-vp rounded"><Icon.Printer className="w-6 hidden" /></button>
                        </div>
                    </div>
                </div>

                <div className="rounded-lg border-2 bg-primary-light bg-opacity-30 border-primary border-opacity-40 p-4 xl:p-8">
                    <div className="flex justify-between items-center xl:mb-2 mb-4">
                        <h2 className="text-xle font-bold text-primary">Recommended Solutions</h2>
                        {selectedDataList.length > 0 ? <Button btnStyle="primary-outline" text="Edit your answers" onClick={() => { EditAnswer() }} /> : <Button btnStyle="secondary-outline" text="Edit your answers" onClick={() => { EditAnswer() }} />}
                    </div>

                    {isLoading && (
                        <Loader />
                    )}
                    {!isLoading && (
                        {
                            ...selectedDataList.length > 0 ?
                                <div>
                                    <div className="flex flex-wrap xl:flex-nowrap items-start  mb-6  w-4/5 xl:w-9/12 ">
                                        <p>Here is a list of products and services that match your needs.<br />
                                            You can deselect any of the product card and click on <strong className="font-bold">Submit your Query</strong> button to submit your personalized selection.</p>
                                    </div>
                                    <div className="flex flex-wrap">
                                        {
                                            dashboardData && dashboardData.length > 0 && dashboardData.map((item, index) => {
                                                return selectedDataList && selectedDataList.length > 0 && selectedDataList.map((item1, index1) => {
                                                    if (item.IDList === item1.IDList) {
                                                        return <CardSolution logo={item.logo}
                                                            checked
                                                            departments={item.departments}
                                                            diffultyLevel={item.diffultyLevel}
                                                            features={item.features}
                                                            learnMoreLink={item.learnMoreLink}
                                                            demoLink={item.demoLink} />
                                                    }
                                                })

                                            })
                                        }
                                    </div>
                                    <div className="mt-4">
                                        <h4 className="text-xxs font-bold mb-1">Beneficiary Departments:</h4>
                                        <div className="flex text-xxs flex-wrap">
                                            <div className="flex mr-4 items-center mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full font-bold">PZ</div>
                                                <div className="font-light">Planning &amp; Zoning</div>
                                            </div>
                                            <div className="flex mr-4 items-center mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full  font-bold">PW</div>
                                                <div className="font-light">Public Works</div>
                                            </div>
                                            <div className="flex mr-4 items-center mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full font-bold">GIS</div>
                                                <div className="font-light">GIS / IT</div>
                                            </div>
                                            <div className="flex mr-4 items-center mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full font-bold">UD</div>
                                                <div className="font-light">Urban Design</div>
                                            </div>
                                            <div className="flex mr-4 items-center mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full font-bold">C</div>
                                                <div className="font-light">Communications</div>
                                            </div>
                                            <div className="flex mr-4 items-center  mb-2">
                                                <div className="w-6 h-6 mr-2 flex-shrink-0 flex justify-center items-center bg-secondary-light border-2 border-vp-peach rounded-full font-bold">ED</div>
                                                <div className="font-light">Economic Development</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    <p className='text-secondary'>Oh Sorry ! No products are matched based on your selection. Please go to Edit your answer button to revise your answers.</p>
                                </div>
                        }
                    )}
                </div>
            </div>

            <div className="mt-10 ">

                <h2 className="text-xle font-bold">Features Comparison</h2>
                <p>Learn how each of these products and solutions stack up against each other.</p>
                {features}
                {/* {cookie.getItem("areaofinterest") == "PLANNING & ZONING" && <TablePZChart />}
                {cookie.getItem("areaofinterest") == "GIS-IT" && <TableGIS />}
                {cookie.getItem("areaofinterest") == "PUBLIC WORKS" && <TablePW />} */}
            </div>

            <div className="mt-12">
                <DashboardDemos />
            </div>
            <div className="mt-12">
                <h2 className="font-bold text-xle mb-2">Other products</h2>
                {
                    otherProducts.length > 0 ?
                        <div>
                            <p>Here are additional products and services that did not match your criteria but are actively used by various state &amp; local governments.</p>
                            <div className="flex flex-wrap -mr-5 mt-4">
                                {
                                    dashboardData && dashboardData.length > 0 && dashboardData.map((item) => {
                                        return otherProducts && otherProducts.length > 0 && otherProducts.map((item1) => {

                                            if (item.IDList === item1.IDList) {

                                                return <CardSolution logo={item.logo}
                                                    checked={false}
                                                    departments={item.departments}
                                                    diffultyLevel={item.diffultyLevel}
                                                    features={item.features}
                                                    learnMoreLink={item.learnMoreLink}
                                                    demoLink={item.demoLink} />
                                            }

                                        });

                                    })
                                }
                            </div>
                        </div>
                        :
                        <div><p>All relevant products and services have been selected. You can change the Area of Interest for additional results.</p></div>
                }
                <div className="flex justify-center my-8">
                    <Button onClick={() => setProductModalVisible(true)} type="primary" text="See full list of products" />
                </div>
            </div>
            <ProductModal isVisible={productModalVisible} closeTrigger={() => setProductModalVisible(false)} />
            <EsriFooter />
        </DashboardLayout>
    )
}

export default Dashboard
